import router from "./routes";
import { useRoutes } from "react-router-dom";
function App() {
  const content = useRoutes(router);
  console.log(content);
  // const { handleOpen } = useContext(MyContext);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      {/* <Main/> */}
      {content}
      {/* <CustomTable />
      <TableAction />
      <Button
        disabled={false}
        text="I am button"
        onClick={() => {
          setIsModalOpen(true);
        }}
        isLoading={false}
      />
      <Telinput />
      <Input type="text" placeholder="Hello" disabled={false} />
      <Accordion data={FakeData} />
      <BasicModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="I am a modal"
        text="This my text. It is cool thet it has worke"
      /> */}
    </>
  );
}

export default App;